import { parseSlugUrl } from './slugify';

const NAME_KEYS = ['name', 'kz_name', 'eng_name', 'ch_name'];

const LANG_KEY = { kz: 'kz_name', en: 'eng_name', cn: 'ch_name' };

export const localizedName = (item, language) => {
  if (!item) return '';
  return item[LANG_KEY[language]] || item.name || '';
};

export const nameSlug = (name) => String(name || '')
  .trim()
  .replace(/[\s/\\?#%&,.;:'"«»()]+/g, '-')
  .replace(/-+/g, '-')
  .replace(/^-|-$/g, '');

const normalize = (slug) => {
  let value = String(slug || '');
  try { value = decodeURIComponent(value); } catch { /* already decoded */ }
  return nameSlug(value).normalize('NFC').toLowerCase();
};

export function buildCategoryUrl(category, subcategory, language) {
  const catSlug = nameSlug(localizedName(category, language));
  if (!catSlug) return '/category';
  const subSlug = nameSlug(localizedName(subcategory, language));
  return subSlug ? `/category/${catSlug}/${subSlug}` : `/category/${catSlug}`;
}

export function findBySlug(list, slug) {
  if (!slug || !Array.isArray(list)) return null;
  const target = normalize(slug);
  const byName = list.find((item) =>
    NAME_KEYS.some((key) => item[key] && normalize(item[key]) === target)
  );
  if (byName) return byName;
  const { id } = parseSlugUrl(slug);
  return id ? list.find((item) => String(item.id) === id) || null : null;
}
